import { render } from "./LogoPrompt.vue?vue&type=template&id=144e52fe&scoped=true"
import script from "./LogoPrompt.vue?vue&type=script&lang=js"
export * from "./LogoPrompt.vue?vue&type=script&lang=js"

import "./LogoPrompt.vue?vue&type=style&index=0&id=144e52fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144e52fe"]])

export default __exports__